const modalAppearanceSetup = (show) => {
    if (!show) return ``;
    else
        return `
        display: block;
    `;
};

export {modalAppearanceSetup};
